import { useState } from 'react';
import Modal, { DialogBody, DialogFooter } from '../ui/Dialog';
import { Button } from '../ui';

const AMBITI = {
  modifica: [
    { id: 'one', titolo: 'Solo questo evento', spiega: 'Le altre occorrenze restano come sono.' },
    { id: 'following', titolo: 'Questo e i successivi', spiega: 'La serie si divide in due: quella prima resta intatta.' },
    { id: 'all', titolo: 'Tutta la serie', spiega: 'Cambia ogni occorrenza, anche quelle già passate.' },
  ],
  elimina: [
    { id: 'one', titolo: 'Solo questo evento', spiega: 'Sparisce questa occorrenza, la serie continua.' },
    { id: 'following', titolo: 'Questo e i successivi', spiega: 'La serie si ferma qui; le occorrenze passate restano.' },
    { id: 'all', titolo: 'Tutta la serie', spiega: 'Elimina la serie intera, passato compreso.' },
  ],
};

/** La conseguenza è scritta sotto ogni opzione: nessuno deve indovinare. */
export default function ScopeDialog({ open, onClose, onConfirm, modo = 'modifica', titolo, loading }) {
  const [scelto, setScelto] = useState('one');
  const opzioni = AMBITI[modo];

  return (
    <Modal open={open} onClose={onClose} size="sm"
      label={modo === 'elimina' ? 'Eliminare l’evento ricorrente' : 'Modificare l’evento ricorrente'}
      description={titolo}>
      <DialogBody className="space-y-2">
        {opzioni.map((opzione, indice) => (
          <label key={opzione.id}
            className={`flex cursor-pointer gap-3 rounded-lg border p-3 transition-colors ${
              scelto === opzione.id ? 'border-brand-500 bg-brand-50' : 'border-line hover:bg-surface-2'}`}>
            <input type="radio" name="ambito" value={opzione.id} checked={scelto === opzione.id}
              data-autofocus={indice === 0 ? '' : undefined}
              onChange={() => setScelto(opzione.id)}
              className="mt-0.5 h-5 w-5 shrink-0 accent-[rgb(var(--brand-500))]" />
            <span>
              <strong className="block text-sm text-ink">{opzione.titolo}</strong>
              <span className="text-xs text-muted">{opzione.spiega}</span>
            </span>
          </label>
        ))}
      </DialogBody>
      <DialogFooter>
        <Button variant="ghost" onClick={onClose}>Annulla</Button>
        <Button variant={modo === 'elimina' ? 'danger' : 'primary'} loading={loading}
          onClick={() => onConfirm(scelto)}>
          {modo === 'elimina' ? 'Elimina' : 'Salva'}
        </Button>
      </DialogFooter>
    </Modal>
  );
}
